<!-- SKD Row -->
<div
  class="flight-row skd-row"
  [class.opacity-5]="
    enhanced &&
    hssBuilderService.isFaded(leg, 'skd') &&
    leg.isCancelled.text === 'False'
  "
  [class.e-cxld]="enhanced && leg.isCancelled.text === 'True'"
>
  <span [class.e-skd]="enhanced && leg.isCancelled.text === 'False'">{{
    isAct ? "ACT " : "SKD "
  }}</span>
  <!-- Day -->
  <span [class.e-day]="enhanced && leg.isCancelled.text === 'False'">{{
    hssBuilderService.getDay(leg, "SKD").padEnd(3, " ")
  }}</span>

  <!-- EQ + FLT rows are combined to show rest duration -->
  <!-- THE "CBA" row uses the depTimeActual and arrTimeSched (don't ask me why) -->
  @if (isAct) {
    <span
      class="text-right"
      [class.e-flt-time]="
        enhanced &&
        leg.isCancelled.text === 'False' &&
        leg.isDhOrSurface.text === 'False'
      "
      [class]="
        hssBuilderService.getChangedClass(
          leg.depTimeActual.didChange || leg.arrTimeActual.didChange,
          index
        )
      "
      >{{
        hssBuilderService
          .getFlightTimeActual(leg, true)
          .padStart(5, " ")
          .padEnd(7, " ")
      }}</span
    >
  } @else if (isCba) {
    <span
      class="text-right"
      [class.e-flt-time]="
        enhanced &&
        leg.isCancelled.text === 'False' &&
        leg.isDhOrSurface.text === 'False'
      "
      [class]="
        hssBuilderService.getChangedClass(
          leg.depTimeActual.didChange || leg.arrTimeActual.didChange,
          index
        )
      "
      >{{
        hssBuilderService.getCbaRestTime(leg).padStart(5, " ").padEnd(7, " ")
      }}</span
    >
  } @else {
    <span
      class="text-right"
      [class.e-flt-time]="
        enhanced &&
        leg.isCancelled.text === 'False' &&
        leg.isDhOrSurface.text === 'False'
      "
      [class]="
        hssBuilderService.getChangedClass(
          leg.depTimeSched.didChange || leg.arrTimeSched.didChange,
          index
        )
      "
      >{{
        hssBuilderService
          .getFlightTimeSched(leg, true)
          .padStart(5, " ")
          .padEnd(7, " ")
      }}</span
    >
  }

  <!-- Dep Sta -->
  <span
    [class.e-dep-sta]="enhanced && leg.isCancelled.text === 'False'"
    [class]="hssBuilderService.getChangedClass(leg.depStation.didChange, index)"
  >
    {{ leg.depStation.text.padEnd(4, " ") }}</span
  >
  <!-- Dep Time -->
  @if (isAct || isCba) {
    <span
      [class.e-dep-time]="enhanced && leg.isCancelled.text === 'False'"
      [class]="
        hssBuilderService.getChangedClass(
          leg.depTimeActualLocal.didChange,
          index
        )
      "
      >{{ leg.depTimeActualLocal.text | hssTime }}
    </span>
  } @else {
    <span
      [class.e-dep-time]="enhanced && leg.isCancelled.text === 'False'"
      [class]="
        hssBuilderService.getChangedClass(
          leg.depTimeSchedLocal.didChange,
          index
        )
      "
      >{{ leg.depTimeSchedLocal.text | hssTime }}
    </span>
  }
  <!-- Meal -->
  <span>{{ " ".padEnd(2, " ") }}</span>
  <!-- Arr Sta -->
  <span
    [class.e-arr-sta]="enhanced && leg.isCancelled.text === 'False'"
    [class]="hssBuilderService.getChangedClass(leg.arrStation.didChange, index)"
    >{{ leg.arrStation.text.padEnd(4, " ") }}</span
  >
  <!-- Arr Time -->
  @if (isAct) {
    <span
      [class.e-arr-time]="enhanced && leg.isCancelled.text === 'False'"
      [class]="
        hssBuilderService.getChangedClass(
          leg.arrTimeActualLocal.didChange,
          index
        )
      "
      >{{ leg.arrTimeActualLocal.text | hssTime }}
    </span>
  } @else {
    <span
      [class.e-arr-time]="enhanced && leg.isCancelled.text === 'False'"
      [class]="
        hssBuilderService.getChangedClass(
          leg.arrTimeSchedLocal.didChange,
          index
        )
      "
      >{{ leg.arrTimeSchedLocal.text | hssTime }}
    </span>
  }
  <!-- Add Code (ignore for REST rows) -->
  <span>{{ "  ".padEnd(2, " ") }}</span>
  <!-- Flt Time -->
  <!-- Always shows REST -->
  @if (isAct) {
    <span>{{ "REST  FAR".padStart(9, " ") }}</span>
  } @else if (isCba) {
    <span>{{ "REST  CBA".padStart(9, " ") }}</span>
  } @else {
    <span>{{ "REST".padStart(5, " ") }}</span>
  }
</div>
